// extracted by mini-css-extract-plugin
export default {"logoMobile":"Logo_logoMobile__+ZdF-","logoImage":"Logo_logoImage__0KZyj"};